import initialState from 'redux/initialState';
import actionTypes from 'redux/actions/actionTypes';
import { actionTypes as customTypes } from 'modules/_shared/redux/resetActions';

import { IncentiveOffer } from 'modules/incentivesMarket/types';

type IncentiveOfferAction = {
  type: string;
  incentiveOffers?: IncentiveOffer[];
  incentiveOffer?: IncentiveOffer;
  incentiveOfferId?: string;
};

const resetStateSociety = () => initialState.incentiveOffers;

const getIncentiveOffers = (action: IncentiveOfferAction) => action.incentiveOffers;

const createIncentiveOffer = (
  incentiveOffers: IncentiveOffer[],
  action: IncentiveOfferAction
) => [action.incentiveOffer, ...incentiveOffers];

const updateIncentiveOfferEntry = (
  incentiveOffers: IncentiveOffer[],
  action: IncentiveOfferAction
) => {
  const updated = action.incentiveOffer;
  if (!updated?._id) return incentiveOffers;

  const exists = incentiveOffers?.some((t) => t._id === updated._id);
  if (!exists) {
    return [updated, ...(incentiveOffers || [])];
  }

  return incentiveOffers?.map((offer: IncentiveOffer) =>
    offer._id === updated._id ? updated : offer
  );
};

const deleteIncentiveOffer = (
  incentiveOffers: IncentiveOffer[],
  action: IncentiveOfferAction
) =>
  incentiveOffers?.filter(
    (offer: IncentiveOffer) => offer._id !== action.incentiveOfferId
  );

export default function reducer(
  incentiveOffers = initialState.incentiveOffers,
  action: IncentiveOfferAction
) {
  switch (action.type) {
    case customTypes.RESET_STATE_SOCIETY:
      return resetStateSociety();

    case actionTypes.GET_INCENTIVE_OFFERS:
      return getIncentiveOffers(action);

    case actionTypes.CREATE_INCENTIVE_OFFER:
      return createIncentiveOffer(incentiveOffers, action);

    case actionTypes.UPDATE_INCENTIVE_OFFER:
      return updateIncentiveOfferEntry(incentiveOffers, action);

    case actionTypes.DELETE_INCENTIVE_OFFER:
      return deleteIncentiveOffer(incentiveOffers, action);

    default:
      return incentiveOffers;
  }
}
